import type {
  OnyxCustomAddress,
  OnyxPointOfInterestAddress,
} from './interfaces';

export enum OnyxAddressType {
  CUSTOM = 'custom',
  POINT_OF_INTEREST = 'point-of-interest',
}

export interface OnyxAddressByType {
  [OnyxAddressType.CUSTOM]: OnyxCustomAddress;
  [OnyxAddressType.POINT_OF_INTEREST]: OnyxPointOfInterestAddress;
}
